var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.226562,
    y: 0.613525,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6903 27.6135V19.4029H22.585L23.0184 16.203H19.6903V14.1601C19.6903 13.2336 19.9604 12.6023 21.3559 12.6023L23.1356 12.6015V9.7396C22.8278 9.70067 21.7712 9.61353 20.5423 9.61353C17.9762 9.61353 16.2195 11.1047 16.2195 13.8432V16.203H13.3174V19.4029H16.2195V27.6134H19.6903V27.6135Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookDark);
export default __webpack_public_path__ + "static/media/FacebookDark.59ab4c8e8b115ecfffca0de2a8564cd4.svg";
export { ForwardRef as ReactComponent };